import abi from './abi.json';
export const ContractABI = abi.abi;
export const ContractAddress = '0xE010497fC49E5EBb7F5baAeaEC9Ec6Fa2519e148';
